import axios from 'axios'
import appConfig from '@/utils/appConfig'
import { genSaveProDis } from '@/api/pubDisPro'

// These session of code are for data entry purpose
const getProDis = ({ commit, state }, payload) => {
  let pdCode = ''
  commit('uiControl/RSTATE_LOADING', { message: 'កំពុងផ្ទុកទិនន្ន័យពីម៉ាសុីនមេ...' }, { root: true })
  /* calculate the pro_code and dis_code based on pf */
  if (payload.ipf === 0) { // District data
    pdCode = payload.pd_code.substring(0, 4)
  } else { // Provincial data
    pdCode = payload.pd_code.substring(0, 4)
  }
  const config = {
    params: {
      acc_code: payload.acc_code,
      pd_code: pdCode
    }
  }
  axios.get(appConfig.climateURL + '/prodis', config)
    .then((response) => {
      if (response.status === 200) {
        commit('LOAD_DATA_PRODIS', response.data)
        commit('uiControl/RSTATE_SUCCESS', null, { root: true })
        if (state.pd.res === '0') {
          commit('uiControl/RSTATE_ERRORS', { errMessage: 'ពុំមានរាជធានី-ខេត្ត/ក្រុង-ស្រុកនេះទេ!' }, { root: true })
        }
      }
    }, (error) => {
      commit('uiControl/RSTATE_ERRORS', { errMessage: error }, { root: true })
      // console.log(error)
    })
}

const loadDefaultProDis = ({ commit, state }) => {
  commit('LOAD_DEFAULT_PRODIS')
}

const saveProDis = ({ commit, state }) => {
  /*
  var d = JSON.parse(JSON.stringify(state.pd))
  let sId = d.state_code.sta_id
  let sCode = 2 // 1 is entry and save, 2 entry & valided, 18 entry and closed ====> UPGRADE IN FUTURE
  // Prepare pre school data
  let data = genSaveProDis(state.pd)
  */
  var fdata = new FormData();
  fdata.append('id_doc', state.pre.id)
  fdata.append('res', state.pre.res)
  fdata.append('doc', JSON.stringify(state.pre.doc))

  commit('uiControl/RSTATE_LOADING', { message: 'កំពុងរក្សាទិនន្ន័យទៅម៉ាសុីនមេ...' }, { root: true })
  axios.post(appConfig.climateURL + '/prodis', fdata)
    .then((response) => {
      // console.log(response.data + 'Done')
      if (response.status === 200) {
        commit('uiControl/RSTATE_SAVE_SUCCESS', { message: 'ទិនន្ន័យរក្សាទុកត្រឹមត្រូវក្នុងម៉ាសុីនមេ' }, { root: true })
      } else {
        commit('uiControl/RSTATE_ERRORS', { errMessage: 'ការរក្សាទុកទិន្នន័យមានបញ្ហា! មូលហេតុ៖ ' + response.data }, { root: true })
      }
    }, (error) => {
      // console.log(error)
      commit('uiControl/RSTATE_ERRORS', { errMessage: error }, { root: true })
    })
}

/* ========== Function for verifying ASCF data =========== */
/*
const verifyPubAscfPre = ({ commit, state }) => {
  // Do the if Logic with state_code with RSTATE_ERRORS and RSTATE_SAVE_SUCCESS
  commit('uiControl/RSTATE_ERRORS', { errMessage: 'ការរក្សាទុកទិន្នន័យមានបញ្ហា! មូលហេតុ៖ pre' }, { root: true })
}

const verifyPubAscfPri = ({ commit, state }) => {
  commit('uiControl/RSTATE_ERRORS', { errMessage: 'ការរក្សាទុកទិន្នន័យមានបញ្ហា! មូលហេតុ៖ pri' }, { root: true })
}

const verifyPubAscfSec = ({ commit, state }) => {
  commit('uiControl/RSTATE_ERRORS', { errMessage: 'ការរក្សាទុកទិន្នន័យមានបញ្ហា! មូលហេតុ៖ sec' }, { root: true })
}
*/
export {
  loadDefaultProDis,
  getProDis,
  saveProDis
  /*
  verifyPubAscfPre,
  verifyPubAscfPri,
  verifyPubAscfSec,
  getReportNoEntry
  */
}
